import axios from 'axios';

// Callback to be set by MemberAuthContext for handling forced logout
let onMemberUnauthorized = null;

export const setOnMemberUnauthorized = (callback) => {
  onMemberUnauthorized = callback;
};

// Axios instance exclusiva para associados (usa member_token no localStorage)
const memberApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1',
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

memberApi.defaults.xsrfCookieName = 'XSRF-TOKEN';
memberApi.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

// Request interceptor - usa member_token separado do token de admin
memberApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('member_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
memberApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (onMemberUnauthorized) {
        onMemberUnauthorized();
      } else {
        localStorage.removeItem('member_token');
        localStorage.removeItem('member_user');
        window.location.href = '/associado/login';
      }
    }

    if (error.response && error.response.status === 403) {
      console.error('Member access forbidden');
    }

    if (!error.response) {
      console.error('Network error - please check your connection');
    }

    return Promise.reject(error);
  }
);

export default memberApi;
